// src/contexts/FeaturesContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';

const API = process.env.REACT_APP_API_URL || 'https://nico-548x.onrender.com/api';
const FeaturesContext = createContext({});

// Defaults — app funciona mesmo sem resposta do backend
const DEFAULTS = {
  garagem: true,
  add_vehicle: true,
  servicos: true,
  validacao: true,
  alertas: true,
  profissionais: true,
  relatorios: true,
  perfil: true,
  pdf_venda: false,
  seguros: false,
  agendamento: false,
  chat_oficina: false,
  historico_fipe: false,
  pro_dashboard: false,
  pro_crm: false,
  admin_panel: false,
};

export function FeaturesProvider({ children }) {
  const [features, setFeatures] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('nico_token');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    fetch(`${API}/features`, { headers })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (data?.features) {
          setFeatures({ ...DEFAULTS, ...data.features });
        }
      })
      .catch(() => {}) // Silencioso — usa defaults
      .finally(() => setLoading(false));
  }, []);

  // Verifica se uma feature está ativa
  const isEnabled = (key) => features[key] === true;

  return (
    <FeaturesContext.Provider value={{ features, loading, isEnabled }}>
      {children}
    </FeaturesContext.Provider>
  );
}

export const useFeatures = () => useContext(FeaturesContext);

// Componente guard — renderiza só se a feature estiver ativa
export function Feature({ flag, children, fallback = null }) {
  const { isEnabled, loading } = useFeatures();
  if (loading) return null;
  return isEnabled(flag) ? children : fallback;
}
